import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import _ from 'lodash';
import config from '../../config';

// TODO
// Error handle
// loading spinner
// possibly remove tools

class RegistrationRaceTotalTableV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            height:props.height,
            loading:true,
            theData:[],
            total:0,
            theTable:null,
            tableHead:[],
            tableBody:[],
            tableFooter:[],
            tableRowTotal:[],
            tableRowTotalPerc:[],
            tableRowStage:[]
      };
    }

    formatNumber(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    async loadOut(){
        let formData;
        let qResp;
        let qData;
        let qWhere="1=1";
        let url=config.apiv2.registrationRaceStage;;
        let total=0;
        let tableHead=[];
        let tableRowTotalPerc=[];
        let tableRowTotal=[];
        let tableRowStage=[];
        let tableBody=[];
        let tableFooter=[];
        let cols=[];
        let overallTotal=0;


        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","sortRank,race,Priority_Category");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){

        
            tableHead.push(<th key={1}>Race/Ethnicity</th>)
            tableBody.push(<td key={69}>Distributution</td>)
            tableRowTotalPerc.push(<td key={98}>Distributution</td>);
            tableRowTotal.push(<td key={98}>Total</td>);
            tableFooter.push(<td key={70}></td>)

            const groupRace= _.chain(qData.features).groupBy("attributes.race").map((value, key) => ({ race: key, stages: value })).value();
            let groupPhase= _.chain(qData.features).groupBy("attributes.Priority_Category").map((value, key) => ({ phase: key, races: value })).value();
            groupPhase = _.sortBy(groupPhase, ['phase']);
            console.log(groupPhase);

            
            // go over once to get overall total and build out header row
            // _.forEach(groupRace,function(value,key){
            for (const [key,value] of Object.entries(groupRace)){
                // builder header and get sum here
                tableHead.push(<th key={value.race}>{value.race}</th>)
                cols.push(value.race);
                let totalRace=0;
                // _.forEach(value.stages,function(valueS,keyS){
                for (const [keyS,valueS] of Object.entries(value.stages)){
                    totalRace+=valueS.attributes.total;
                }
                // });
                overallTotal+=totalRace;
            }
                // });

            // loop over again to build race rows
            // _.forEach(groupRace,function(value,key){
            for (const [key,value] of Object.entries(groupRace)){
                // builder header and get sum rows here
                let totalRace=0;
                // _.forEach(value.stages,function(valueS,keyS){
                for (const [keyS,valueS] of Object.entries(value.stages)){
                    totalRace+=valueS.attributes.total;
                }
                // });
                let percCalc=(totalRace/overallTotal)*100;
                percCalc=Math.round(percCalc * 10) / 10;
                tableRowTotalPerc.push(<td key={percCalc}>{percCalc}%</td>)
                tableRowTotal.push(<td key={totalRace}>{this.formatNumber(totalRace)}</td>)
            }
            // });
            tableRowTotalPerc.push(<td key="12166545654"></td>)
            tableRowTotal.push(<td key={overallTotal}>{this.formatNumber(overallTotal)}</td>)

            // loop over the phase object and build out the stage rows
            tableRowStage.push(<tr><td colSpan={cols.length+2} key={cols.length+2}><strong>Phase</strong></td></tr>);
            for (const [key,value] of Object.entries(groupPhase)){ 
                // maybe sort the races object before loop just to be safe
                let tempTd=[];
                let tempPercTd=[];
                let sumStage=0;
                for (const [keyR,valueR] of Object.entries(value.races)){ 
                    sumStage+=valueR.attributes.total;
                }
                for (const [keyR,valueR] of Object.entries(value.races)){ 
                    tempTd.push(<td key={valueR.attributes.total+69}>{this.formatNumber(valueR.attributes.total)}</td>);
                    let tempPerc=(valueR.attributes.total/sumStage)*100;
                    tempPerc=Math.round(tempPerc * 10) / 10
                    tempPercTd.push(<td key={valueR.attributes.total+22}><i>{tempPerc}%</i></td>);
                }
                tableRowStage.push(<><tr><td key={value.phase+"YAYA"}><strong>{value.phase}</strong></td>{tempTd}<td key={sumStage+72}>{this.formatNumber(sumStage)}</td></tr><tr><td key={value.phase+"YAYAYA"}></td>{tempPercTd}<td key={value.phase+"YAYAYAYAYA"}></td></tr></>);
            }

            tableHead.push(<th key="Total">Total</th>)
            tableBody.push(<td key="0"></td>)
            tableFooter.push(<td key={total}>{this.formatNumber(total)}</td>)

            this.setState({
                loading:false,
                total:this.formatNumber(total),
                tableHead:tableHead,
                tableBody:tableBody,
                tableRowStage:tableRowStage,
                tableRowTotalPerc:tableRowTotalPerc,
                tableRowTotal:tableRowTotal,
                tableFooter:tableFooter,
                error:false,
            });
        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }


    render() {
        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <Table striped bordered hover size="sm" responsive style={{fontSize:"10pt",height:this.state.height}}>
                {/* height:"98vh", */}
                    <thead>
                        <tr style={{backgroundColor:"#b63a3a",color:"#FFFFFF"}}>
                            {this.state.tableHead}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {this.state.tableRowTotalPerc}
                        </tr>
                        <tr>
                            {this.state.tableRowTotal}
                        </tr>
                        {this.state.tableRowStage}
                    </tbody>
                </Table>
            );
        }
    }
}

export default RegistrationRaceTotalTableV2;